export function useLang() {
  const route = useRoute()
  const lang = computed(() => route.params.lang)
  const isAr = computed(() => lang.value === 'ar')
  return { lang, isAr }
}
